import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-2 border-b" }
const _hoisted_2 = { class: "p-1" }
const _hoisted_3 = { class: "truncate" }
const _hoisted_4 = {
  key: 0,
  class: "px-2 py-3 text-center text-gray-500"
}

import { computed, ref } from 'vue';
import { Checkbox } from '@/components/ui/checkbox';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { ScrollArea } from '@/components/ui/scroll-area';
import type { SeriesRanking } from '@/composables/records/useGroupedWeeklyAggregation';

/*
 * A grouped weekly chart's own multi-select: every series in the fetched period, ranked by total,
 * with a checkbox per series. The trigger's own label already says how many of how many are
 * checked - the page words it - so nothing here restates the count.
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'SeriesSelector',
  props: {
    ranking: {},
    selectedIds: {},
    label: {}
  },
  emits: ["toggle"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const search = ref('');

const visibleRanking = computed(() => {
    const term = search.value.trim().toLowerCase();

    return term ? props.ranking.filter((entry) => entry.name.toLowerCase().includes(term)) : props.ranking;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Popover), null, {
    default: _withCtx(() => [
      _createVNode(_unref(PopoverTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), {
            variant: "outline",
            size: "sm",
            class: "font-medium data-[state=open]:bg-gray-100"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.label), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(PopoverContent), {
        align: "end",
        class: "p-0 w-64"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(Input), {
              modelValue: search.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
              placeholder: _ctx.$t('global.uiElements.dataTable.filter.texts.search'),
              class: "h-9"
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createVNode(_unref(ScrollArea), { class: "max-h-64" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleRanking.value, (entry) => {
                  return (_openBlock(), _createElementBlock("label", {
                    key: entry.id,
                    class: "flex items-center gap-2 rounded px-2 py-1.5 cursor-pointer hover:bg-gray-100"
                  }, [
                    _createVNode(_unref(Checkbox), {
                      checked: _ctx.selectedIds.has(entry.id),
                      "onUpdate:checked": ($event: any) => (emit('toggle', entry.id))
                    }, null, 8, ["checked", "onUpdate:checked"]),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(entry.name), 1)
                  ]))
                }), 128)),
                (!visibleRanking.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('global.uiElements.dataTable.filter.texts.noOptions')), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})